var React = require('react');

function CloseCross (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1L13 13","strokeWidth":"1.6","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M1 13L13 0.999999","strokeWidth":"1.6","strokeLinecap":"round","key":1})]);
}

CloseCross.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = CloseCross;

CloseCross.default = CloseCross;
